import React from 'react';
import styled from 'styled-components';
import Coral from '../../components/Coral/Coral';
import Target from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:300px;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 60vh;

  }
`;



class CardCoral extends React.Component {
  render () {
   return (

<Container>
    
    <Viz>
      <Coral />

    </Viz>

   <ReusableDetailCard
   trend= {Target}
   metricsm="Tropical Regions of Pacific, Atlantic, Indian Oceans"
   diagnosis="Coral ecosystems provide food, protect coastlines from storms, and make up vital spawning and nursery grounds for economically important fish species. Changes in ocean temperature and acidity are leading to coral bleaching."
   prediction="Overfishing, disease and invasive species are leading to the loss of ecologically and economically important fish species. Damaged reefs, additionally, cannot take in carbon from the atmpsphere, accelerating climate change."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
</Container>

  );
 }
}

export default CardCoral;
